<template lang="html">

  <section 
    :class="['pe_grid pe_crossword', {'pe_complete': completed }]"
  >
    <transition name="fade">
      <div 
        class="pe_blank"
        v-if="!grid.loaded"
      >
        <Spinner type="cube" />
      </div>
    </transition>

    <transition name="fade">
      <div 
        :class="['pe_grid-wrapper', {'pe_loaded': grid.loaded}]"
        v-if="grid.loaded"
      >
        <div
          class="pe_cell-row"
          v-for="(row, i) in grid.rows"
          :key="`col-${i}`"
        >
          <Cell
            v-for="(col, j) in grid.cols"
            :key="`row-${j}`"
            :row="i"
            :col="j"
          />
        </div>
        
      </div>
    </transition>

  </section>

</template>

<script lang="js">

  import { mapActions, mapState, mapGetters } from 'vuex'
  import Cell from './Cell'
  import Spinner from '@puzzleapps/shared/src/components/ui/Spinner'

  export default  {
    name: 'grid',
    props: [
      'type',
    ],

    components: {
      Cell,
      Spinner,
    },

    mounted() {
      this.gameInit(this.type)

      // TODO use a global event
      this.onKeyDown = this.onKeyDown.bind(this)
      window.addEventListener('keydown', this.onKeyDown)
    },

    destroyed() {
      this.clearPuzzleState()
      window.removeEventListener('keydown', this.onKeyDown)
    },

    methods: {
      ...mapActions({
        gameInit: 'game/init',
        clearPuzzleState: 'game/clearPuzzleState',
        setInputAtPos: 'grid/setInputAtPos',
        backLetter: 'grid/backLetter',
        selectCell: 'grid/selectCell',
        undoRedo: 'undoRedo/undoRedo',
        toggleIsAcross: 'grid/toggleIsAcross',
        selectCluesByCell: 'cluelist/selectCluesByCell',
        selectNextLetter: 'grid/selectNextLetter',
        selectNextClue: 'cluelist/selectNextClue',
        selectPrevClue: 'cluelist/selectPrevClue',
        keyPressed: 'grid/keyPress',
      }),

      // crossword only
      // TODO put in store

      // TODO see if we can set these individually from the cell component or
      // set in its own file
      onKeyDown(e) {

        if (!this.selectedCell) return
        let key = e.key

        let payload = {
          row: this.selectedCell.row, 
          col: this.selectedCell.col,
          input: key.toUpperCase(),
        }

        // dev cheat
        if (e.shiftKey && e.ctrlKey && key.toLowerCase() === 'd') {
          let remaning = false
          this.grid.cells.forEach(row => {
            row.forEach(cell => {
              if (!cell.isGiven) {
                if (remaning) {
                  this.setInputAtPos({
                    row: cell.row, 
                    col: cell.col,
                    input: cell.solution,                  
                  })
                }
                remaning = true
              }
            })
          })
        }

        e.preventDefault();
        this.keyPressed(payload);
        return
        //redo
        if ((e.shiftKey && e.ctrlKey && key.toLowerCase() === 'z')) {          
          return this.undoRedo(true)
        }
        // undo
        if (e.ctrlKey && key.toLowerCase() === 'z') {          
          return this.undoRedo()
        }
        // backspace / delete
        if (key === 'Backspace' || key === 'Delete') {
          payload.input = 0
          this.setInputAtPos(payload)
          this.backLetter(payload)
          return
        }

        if (key === 'Enter' || key === 'Tab') {
          e.preventDefault();
          //console.log("Tab key v1")
          if (e.ctrlKey)
            return this.selectPrevClue()       
          else        
            return this.selectNextClue()   

        }


        if (key === 'Shift') {
          this.toggleIsAcross()
          if (this.noNeighbouringCells(this.selectedCell.row, this.selectedCell.col))
            this.toggleIsAcross()
          return
        }

        // arrows
        if (this.isArrow(key)) {
          return this.nextWhiteCell(key, payload.row, payload.col)
        }

        // are we entering a letter?
        if (this.isLetter(key) && !e.ctrlKey) {
          // payload.input = key
          payload.input = key.toUpperCase()
          this.setInputAtPos(payload)    

          this.selectNextLetter({
            row: this.selectedCell.row, 
            col: this.selectedCell.col
          })
        }

      },

      // TODO: should be in crossword grid store
      nextWhiteCell(key, row, col) {
        if      (key == 'ArrowLeft')    col--
        else if (key == 'ArrowRight')   col++
        else if (key == 'ArrowUp')      row--
        else if (key == 'ArrowDown')    row++
        
        if (
          (col < 0 && !this.isAcross && row <= 0) ||
          (col <= 0 && this.isAcross && row < 0) ||
          col < 0 && this.isAcross ||
          row < 0 && !this.isAcross
        ) {
          return this.selectPrevClue()
        }

        if (
          col >= this.grid.cols ||
          row >= this.grid.rows
        ) {
          return this.selectNextClue()
        }

        if (
          col < 0 && !this.isAcross || 
          row < 0 && this.isAcross
        ) {
          return this.backLetter({
            row: this.selectedCell.row, 
            col: this.selectedCell.col,
          })
        }

        if (this.noNeighbouringCells(row, col)) {
          this.toggleIsAcross()
        }
        
        if (
          (this.grid.cells[row][col].isBlack && key == 'ArrowRight' && this.isAcross) ||
          (this.grid.cells[row][col].isBlack && key == 'ArrowDown' && !this.isAcross) 
        ) {
          return this.selectNextClue()
        }              

        if (
          (this.grid.cells[row][col].isBlack && key == 'ArrowLeft' && this.isAcross) ||
          (this.grid.cells[row][col].isBlack && key == 'ArrowUp' && !this.isAcross) 
        ) {
          return this.selectPrevClue()
        }        

        if (
          (this.grid.cells[row][col].isBlack && key == 'ArrowLeft' && !this.isAcross) ||
          (this.grid.cells[row][col].isBlack && key == 'ArrowUp' && this.isAcross)
        ) {
          return this.backLetter({
            row: this.selectedCell.row, 
            col: this.selectedCell.col,
          })
        }        

        if (
          (this.grid.cells[row][col].isBlack && key == 'ArrowRight' && !this.isAcross) ||
          (this.grid.cells[row][col].isBlack && key == 'ArrowDown' && this.isAcross) 
        ) {
          return this.selectNextLetter({
            row: this.selectedCell.row, 
            col: this.selectedCell.col,
          })
        }

        this.selectCell({row: row, col: col})

        this.selectCluesByCell(this.grid.cells[row][col])
      },

      isNumber(key) {
        return !isNaN(key)
      },

      isLetter(key) {
        return key.toLowerCase() != key.toUpperCase() && key.length === 1
      },

      isArrow(key) {
        return key === 'ArrowLeft' || 
               key === 'ArrowRight' || 
               key === 'ArrowUp' || 
               key === 'ArrowDown' 
      }

      ///////////////////////////////////////
    },
    
    computed: {
      ...mapState({
        grid: state => state.grid,
        isPencil: state => state.grid.isPencil,
        isPlaying: state => state.game.isPlaying,
        completed: state => state.game.completed,
        puzzleId: state => state.game.puzzleId,
        gameType: state => state.game.type,

        //crossword
        clues: state => state.cluelist.clues,
        isAcross: state => state.grid.isAcross,
        selectedCell: state => state.grid.selectedCell,
      }),
      
      ...mapGetters({        
        // crossword
        noNeighbouringCells: 'grid/noNeighbouringCells',
      }), 

    }
}


</script>

<style scoped lang="scss">

  @import '@puzzleapps/shared/src/style/variables';

  .pe_grid-wrapper.fade-leave-active,
  .fade-enter-active {
    transition: all 0.5s cubic-bezier(1.0, 0.5, 0.8, 1.0)!important;
  }
  
  .pe_grid-wrapper.fade-leave-to,
  .fade-enter, 
  .slide-fade-leave-to {
    opacity: 0;
  }

  .pe_grid {
    width: 100%;
    box-sizing: border-box;
    position: relative;

    &:before {
      content: "";
      display: block;
      padding-bottom: 100%;
    }
    
    .pe_blank {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f5f5f5;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      border: 2px solid white;


      .pe_spinner {
        transition: opacity 0.5s;
      }

      &.fade-leave-active,
      &.fade-leave-to {
        position: absolute;

        .pe_spinner {
          opacity: 0;
        }
      }
    }

    .pe_grid-wrapper {
      position: absolute;
      width: 100%;
      box-sizing: border-box;
      background: #fff;
      top: 0;
      left: 0;

      &.pe_loaded {        
        border: 0px solid var(--thick-border-color);
        border-right-width: 1px;
        border-bottom-width: 1px;
      }
    }

    .pe_cell-row {
      display: flex;
      width: 100%;
    }

  }
</style>

